/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Checks if county= is in the URL and tries to pre-select the county

// Create "window.Shoppad.apps.infiniteoptions" object if it doesn't already exist
"Shoppad.apps.infiniteoptions".split(".").reduce(function(o, x) { if (!o[x]) {o[x] ={};} return o[x] }, window);

// Define beforeReady callback
window.Shoppad.apps.infiniteoptions.beforeReady = function(subscribe) {
  subscribe('appLoad', function(event) {
    
    if (window.location.href.indexOf("county=") > -1) {
		var url = new URL(window.location);
		var county = url.searchParams.get("county");
		county = county.charAt(0).toUpperCase() + county.slice(1);
      
      	if (optionExists(county, document.getElementById('County-0-0'))) {
			document.getElementById('County-0-0').value = county;
      	}
      
	}
    
  });
};

window.addEventListener('load', function () {
	if (window.location.href.indexOf("county=") > -1) {
		var url = new URL(window.location);
		var county = url.searchParams.get("county");
		county = county.charAt(0).toUpperCase() + county.slice(1);
            
      	// Update product title to match county name
      	$("h1.product__title").text("A4 / A3 - "+ county +" County Print | Premium Wall Print");
	}
});


/*
 * Helper Functions
 *
 */

function optionExists ( needle, haystack ) {
    var optionExists = false,
        optionsLength = haystack.length;

    while ( optionsLength-- )
    {
        if ( haystack.options[ optionsLength ].value === needle )
        {
            optionExists = true;
            break;
        }
    }
    return optionExists;
}